import { createContext } from 'react';
import { DEFAULT_SML_THEME, DEFAULT_SML_THEME_PREFERENCE, SMLTheme, SMLThemePreference } from './smlTheme';

export interface SMLThemeContextValue {
  /** The choice of the user: `system`, `light` or `dark`. */
  preference: SMLThemePreference;
  /** The theme on screen: the choice, or the device color scheme for `system`. */
  theme: SMLTheme;
  setPreference: (preference: SMLThemePreference) => void;
  /** Stores an explicit light or dark choice. */
  setTheme: (theme: SMLTheme) => void;
  /** Flips the theme on screen and stores the explicit result. */
  toggleTheme: () => void;
}

export const SMLThemeContext = createContext<SMLThemeContextValue>({
  preference: DEFAULT_SML_THEME_PREFERENCE,
  theme: DEFAULT_SML_THEME,
  setPreference: () => undefined,
  setTheme: () => undefined,
  toggleTheme: () => undefined,
});
